<template>
  <div class="login-record-page dark-theme">
    <!-- 主内容区 -->
    <div class="login-record-container">
      <!-- 登录记录卡片 -->
      <div class="section-card">
        <div class="card-header">
          <a-icon type="clock-circle" class="card-icon" />
          <h3 class="card-title">{{ translate('loginRecord.title') }}</h3>
        </div>

        <!-- 登录记录表格 -->
        <a-table
          :columns="columns"
          :data-source="datalist"
          rowKey="infoId"
          :loading="dataLoading"
          :pagination="pagination"
          @change="handlePaginationChange"
          size="middle"
          class="dark-table"
        >
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginRecordPage',
  inject: ['languageState'],
  computed: {
    currentLanguage() {
      return this.languageState ? this.languageState.languageCode : 'zh';
    },
    columns() {
      return [
        {
          title: this.translate('loginRecord.column.username'),
          dataIndex: 'userName',
          key: 'userName',
          width: 150,
        },
        {
          title: this.translate('loginRecord.column.loginTime'),
          dataIndex: 'loginTime',
          key: 'loginTime',
          width: 200,
        },
        {
          title: this.translate('loginRecord.column.ip'),
          dataIndex: 'ipaddr',
          key: 'ipaddr',
          width: 150,
        },
        {
          title: this.translate('loginRecord.column.os'),
          dataIndex: 'os',
          key: 'os',
          width: 150,
        },
        {
          title: this.translate('loginRecord.column.browser'),
          dataIndex: 'browser',
          key: 'browser',
          width: 150,
        },
      ];
    },
  },
  data() {
    return {
      datalist: [],
      rowKey: 'index',
      dataLoading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
        showTotal: (total) => {
          return this.translate('loginRecord.pagination.total', { total });
        },
      },
      timer: '', // 定时器名称
    };
  },
  methods: {
    // 国际化翻译方法
    translate(key, params = {}) {
      const lang = this.currentLanguage;
      const translations = {
        'loginRecord.title': lang === 'zh' ? '登录记录' : 'Login Record',
        'loginRecord.column.username': lang === 'zh' ? '用户名' : 'Username',
        'loginRecord.column.loginTime': lang === 'zh' ? '登录时间' : 'Login Time',
        'loginRecord.column.ip': lang === 'zh' ? 'IP地址' : 'IP Address',
        'loginRecord.column.os': lang === 'zh' ? '操作系统' : 'Operating System',
        'loginRecord.column.browser': lang === 'zh' ? '浏览器' : 'Browser',
        'loginRecord.pagination.total': lang === 'zh' ? `共 ${params.total} 条记录` : `Total ${params.total} records`,
        'loginRecord.message.loginWarning': lang === 'zh' ? '请重新登录！' : 'Please login again!',
      };
      return translations[key] || key;
    },
    // 登录状态检查
    getLoginStatus() {
      this.$request.get('/ums/isLoginStates').then((res) => {
        if (res.data.code === 5000) {
          this.$router.push('/login')
          window.localStorage.clear()
          this.$message.warning(this.translate('loginRecord.message.loginWarning'))
        }
      })
        .catch((e) => {
          console.log(e)
        })
    },
    // 启动定时检查
    start() {
      this.timer = setInterval(this.getLoginStatus, 10000)
    },
    // 获取登录记录数据
    fetchLoginRecordData() {
      this.dataLoading = true;
      this.$request.get('/ums/getLoginRecord', {
        params: {
          pageNum: this.pagination.current,
          pageSize: this.pagination.pageSize,
        },
      }).then((res) => {
        if (res.data.code === 200) {
          this.datalist = res.data.data.list;
          this.pagination.total = res.data.data.total;
        }
      })
        .catch((e) => {
          console.error('获取登录记录失败:', e);
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },
    // 处理分页变化
    handlePaginationChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.fetchLoginRecordData();
    },
  },
  mounted() {
    this.fetchLoginRecordData();
    this.start();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
};
</script>

<style scoped lang="less">
// 深色主题全局样式
.dark-theme {
  background: #2d2c28;
  color: #ffffff;
  // min-height: 100vh;
}

// 主容器样式
.login-record-container, .flow-record-container, .sub-account-container, .traffic-container {
  padding: 20px;
  margin: 0 auto;
}

// 卡片通用样式
.section-card {
  background: #33342e;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  color: #ffffff !important;

  &:hover {
    border-color: rgba(21, 129, 198, 0.3);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    transform: translateY(-2px);
  }
}

// 卡片头部
.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.card-icon {
  font-size: 20px;
  color: #00ea90;
  background: rgba(0, 234, 144, 0.1);
  padding: 8px;
  border-radius: 8px;
}

.card-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff !important;
  margin: 0;
}

// 操作区/搜索区
.action-bar, .search-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding: 20px;
  background: #1f1e1b;
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
}

.search-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.dark-form-item {
  :deep(.ant-form-item-label > label) {
    color: rgba(255, 255, 255, 0.9) !important;
    font-weight: 500;
  }
}

// 统计项
.master-stats {
  display: flex;
  gap: 20px;
}
.stat-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.stat-label {
  font-size: 14px;
  color: #aaa;
}
.stat-value {
  font-size: 18px;
  font-weight: 700;
  color: #00ea90;
}

// 表单元素暗黑风
:deep(.ant-input),
:deep(.ant-input-number),
:deep(.ant-input-password input),
:deep(.ant-select-selection),
:deep(.ant-select-selector),
:deep(.ant-select-selection--single) {
  background: #1f1e1b !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 8px !important;
  color: #fff !important;
  height: 40px !important;
  transition: all 0.3s ease !important;
  box-shadow: none !important;
}

:deep(.ant-select-selection__rendered) {
  line-height: 38px !important;
  color: #fff !important;
}

:deep(.ant-input:hover),
:deep(.ant-input-number:hover),
:deep(.ant-select-selection:hover) {
  border-color: #1581c6 !important;
}

:deep(.ant-input:focus),
:deep(.ant-input-number:focus),
:deep(.ant-select-focused .ant-select-selection) {
  border-color: #00ea90 !important;
  box-shadow: 0 0 0 2px rgba(0, 234, 144, 0.2) !important;
}

:deep(.ant-select-dropdown) {
  background: #33342e !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
}
:deep(.ant-select-dropdown-menu-item) {
  color: #ddd !important;
}
:deep(.ant-select-dropdown-menu-item-active),
:deep(.ant-select-dropdown-menu-item-selected) {
  background: rgba(21, 129, 198, 0.2) !important;
  color: #fff !important;
}

// 按钮暗黑风
:deep(.ant-btn-primary) {
  background: #1581c6 !important;
  border-color: #1581c6 !important;
  border-radius: 8px;
  height: 40px;
  font-weight: 600;
  color: #fff !important;
}

:deep(.ant-btn-primary:hover) {
  background: #126ba5 !important;
  border-color: #126ba5 !important;
}

:deep(.ant-btn-danger) {
  background: #f5222d !important;
  border-color: #f5222d !important;
  border-radius: 8px;
  height: 40px;
  color: #fff !important;
}
:deep(.ant-btn-danger:hover) {
  background: #cf1322 !important;
  border-color: #cf1322 !important;
}

.action-btn {
  background: #1581c6 !important;
  border: none !important;
  padding: 0 24px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #ffffff !important;
  height: 40px !important;
  transition: all 0.3s ease !important;

  &:hover {
    transform: translateY(-1px) !important;
    box-shadow: 0 4px 12px rgba(21, 129, 198, 0.3) !important;
  }
}

// 深色表格样式
.dark-table {
  background: transparent !important;
  color: #ffffff !important;

  :deep(.ant-table) {
    background: transparent !important;
  }

  :deep(.ant-table-thead > tr > th) {
    background: #1f1e1b !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
    color: rgba(255, 255, 255, 0.8) !important;
    font-weight: 700 !important;
    font-size: 14px;
    padding: 16px 12px;
  }

  :deep(.ant-table-tbody > tr) {
    background: transparent !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
  }

  :deep(.ant-table-tbody > tr > td) {
    color: rgba(255, 255, 255, 0.7) !important;
    font-size: 14px;
    padding: 16px 12px;
    background: #2d2c28 !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
  }

  :deep(.ant-table-tbody > tr:hover > td) {
    background: rgba(21, 129, 198, 0.2) !important;
  }

  :deep(.ant-pagination) {
    color: rgba(255, 255, 255, 0.6) !important;
  }

  :deep(.ant-pagination-item) {
    background: #1f1e1b !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
  }

  :deep(.ant-pagination-item a) {
    color: rgba(255, 255, 255, 0.6) !important;
  }

  :deep(.ant-pagination-item-active) {
    background: linear-gradient(135deg, #1581c6 0%, #00ea90 100%) !important;
    border-color: transparent !important;
  }

  :deep(.ant-pagination-item-active a) {
    color: #ffffff !important;
  }

  :deep(.ant-table-placeholder) {
    background: #1f1e1b !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
  }

  :deep(.ant-empty) {
    color: rgba(255, 255, 255, 0.5) !important;
    background: transparent !important;
    border: none !important;
    padding: 40px 20px !important;
    margin: 20px 0 !important;
  }

  :deep(.ant-empty-description) {
    color: rgba(255, 255, 255, 0.5) !important;
  }
}

// 模态框深色样式
:deep(.ant-modal-content) {
  background: #33342e !important;
  color: #fff;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}
:deep(.ant-modal-header) {
  background: #2d2c28 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px 12px 0 0;
}
:deep(.ant-modal-title) {
  color: #fff !important;
  font-weight: 700;
}
:deep(.ant-modal-close-x) {
  color: #aaa !important;
}
:deep(.ant-modal-close:hover .ant-modal-close-x) {
  color: #fff !important;
}
:deep(.ant-form-item-label > label) {
  color: #ddd !important;
}

// 图表样式
.traffic-chart {
  border-radius: 16px;
  background: #1f1e1b !important;
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
  padding: 20px;
  height: 520px !important;
  width: 100% !important;
}

// 响应式设计
@media (max-width: 768px) {
  .login-record-container, .flow-record-container, .sub-account-container, .traffic-container {
    padding: 16px;
  }

  .action-bar, .search-section {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .dark-table {
    :deep(.ant-table-thead > tr > th),
    :deep(.ant-table-tbody > tr > td) {
      padding: 12px 8px;
    }
  }
}
</style>